/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Modal, Tabs, Select, message, notification, Row, Col, Form, Input, Spin, Checkbox, Radio, Space, Popconfirm } from 'antd';
import { useAppContext, APP_ACTIONS, userId } from "../../../context/appContext";
import testProfile from "../../common/helpers/test-profile";
import exchanges from "../../common/exchanges";
import exchangesWithParams from "../../common/exchanges-with-params";
import fetchSourceMarkets from "../../common/helpers/fetch-source-markets";
import fetchUniswapPairs from "../../common/helpers/fetch-uniswapv2-pairs";
import { CloseOutlined, PlusCircleOutlined, WarningOutlined } from '@ant-design/icons';

import CodeEditor from '@uiw/react-textarea-code-editor';
import createScript from "../../common/helpers/create-script";
import updateScript from "../../common/helpers/update-script";
import deleteScript from "../../common/helpers/delete-script";
import fetchScript from "../../common/helpers/fetch-script";
import createProfile from "../../common/helpers/create-profile";
import fetchProfiles from "../../common/helpers/fetch-profiles";
import fetchMarkets from "../../common/helpers/fetch-profile-markets";
import calculateConversion from "../../common/helpers/calculate-conversion";
import { isSameAsset, splitSymbol } from "../../common/helpers/asset-alias";


import fetchAv from "../../common/helpers/fetch-av-exchanges";

import dex from "../../common/dex";
const { TextArea } = Input;
const SelectRebalanceProfile = ({ displayRebalanceProfile, setDisplayRebalanceProfile, onChangeRebalanceProfile, orderItem, setOrderItem, savedScripts }) => {
    const {
        state: { profiles, customMarkets, exchangeMarkets },
        dispatch
    } = useAppContext();
    const [step, setStep] = useState(0);
    const [profile, setProfile] = useState({});
    const [newProfile, setNewProfile] = useState({
        name: null,
        exchange: null,
        api_key: null,
        api_secret: null,
        custom_api_url: null,
        custom_websocket_url: null,
        is_sandbox: false,
    });
    const [customURls, setCustomUrls] = useState({
        custom_api_url: 'https://api.hollaex.com',
        custom_websocket_url: 'wss://api.hollaex.com/stream',
        is_sandbox: false,
    });

    const [createAction, setCreateAction] = useState(true);
    const [profileBalance, setProfileBalance] = useState()
    const [subprofileBalance, setSubprofileBalance] = useState()
    const [profileLoading, setProfileLoading] = useState(false)
    const [subprofileLoading, setSubprofileLoading] = useState(false)
    const [rebalanceSymbol, setRebalanceSymbol] = useState();
    const [markets, setMarkets] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [customUniswapPair, setCustomUniswapPair] = useState();
    const [displayAddToken, setDisplayAddToken] = useState();
    const [addToken, setAddToken] = useState();
    const [uniswapPairs, setUniswapPairs] = useState(JSON.parse(localStorage.getItem(`uniswap_token_list`)) || []);
    const [selectedNetwork, setSelectedNetwork] = useState('mainnet');

    const [customScripts, setCustomScripts] = useState([]);
    const [scriptName, setScriptName] = useState();
    const [scriptLibraries, setScriptLibraries] = useState([]);
    const [selectedCustomScript, setSelectedCustomScript] = useState();
    const [displayCustomScript, setDisplayCustomScript] = useState(false);

    const defaultCode = `async function execute () {\n //Write your logic here \n \n\n return; // return a value that represents source price \n}  \n\nmodule.exports = execute(); // Do not change this line`
    const [code, setCode] = useState(defaultCode);

    const [rebalanceOrderType, setRebalanceOrderType] = useState('market');
    const [rebalanceSpread, setRebalanceSpread] = useState();
    const [firstAssetRebalance, setFirstAssetRebalance] = useState();
    const [secondAssetRebalance, setSecondAssetRebalance] = useState();
    const [displaySubRebalance, setDisplaySubRebalance] = useState(false);


    const [subRebalanceProfile, setSubRebalanceProfile] = useState();

    const [assetRebalanceInfo, setAssetRebalanceInfo] = useState({
        type: null,
        rebalance_profile: null,
        order_type: null,
        spread: null,
        symbol: null,
        asset: null,
    })

    const [rebalanceAssets, setRebalanceAssets] = useState([]);

    const [errorMessage, setErrorMessage] = useState('');
    const [conversionObj, setConversionObj] = useState({})
    const [preventOk, setPreventOk] = useState(false);
    const [displayCustomMarket, setDisplayCustomMarket] = useState();
    const [displayWarning, setDisplayWarning] = useState();

    const [selectedExchange, setSelectedExchange] = useState(null);
    const [avaliableExhanges, setAvailableExchanges] = useState()
    // localStorage.removeItem('uniswap_token_list')
    useEffect(() => {

        console.log(orderItem?.rebalance)
        if (orderItem?.rebalance) {
            setCreateAction(false);

            const found = profiles.find(profile => profile.id === orderItem?.rebalance?.id);
            if (found) {
                setProfile({
                    ...profile,
                    exchange: found?.exchange
                })

                setNewProfile(found);
                setRebalanceSymbol(orderItem?.rebalance_symbol);
                setRebalanceOrderType(orderItem?.rebalanceOrderType);
                setRebalanceSpread(orderItem?.rebalanceSpread);
                setRebalanceAssets(orderItem?.rebalanceAssets);
            }
        }

        if (Array.isArray(savedScripts)) {
            setCustomScripts([...savedScripts])

            if (orderItem?.rebalance?.type === 'custom_script') {
                const foundScript = savedScripts.find(script => script.id === orderItem?.rebalance?.id);
                if (foundScript) {
                    setDisplayCustomScript(true);
                    setSelectedCustomScript(orderItem?.rebalance?.id);
                    setScriptLibraries(foundScript.libraries);
                    setScriptName(foundScript.script_name);
                    setCode(foundScript.script);
                }
            }
        }

    }, [])

    const handleChange = (value) => {
        setSelectedExchange(value);

        message.loading({ content: 'finding conversion...', key: 'conversion', duration: 0 });

        fetchAv({ exchangeId: value, pair: conversionObj?.customConfig?.symbol,
            isSandbox: customURls.is_sandbox,
            custom_urls: {
                custom_api_url: customURls.custom_api_url,
                custom_websocket_url: customURls.custom_websocket_url,
            }
         }).then((a => {
            if (!a.error) { 
                calculateConversion({ 
                    exchangeId: orderItem?.source,
                    selectedSymbol: orderItem?.symbol,
                    marketFocus: assetRebalanceInfo?.symbol,
                    userId,
                    isSandbox: orderItem?.isSandbox,
                    isRebalance: true,
                    conversion: orderItem?.conversionMarket,
                    sourceSymbol: orderItem?.source_symbol,
                    isSandbox: customURls.is_sandbox,
                    custom_urls: {
                        custom_api_url: customURls.custom_api_url,
                        custom_websocket_url: customURls.custom_websocket_url,
                    },
                    overridePrice: {
                    first_asset: conversionObj?.customConfig?.symbol.split('/')[0].toLowerCase(),
                    second_asset:  conversionObj?.customConfig?.symbol.split('/')[1].toLowerCase(),
                    price: a.price,
                    symbol: conversionObj?.customConfig?.symbol,
                    id: 9999999
                } }).then(res => {
                    if (res.error) {
                        setErrorMessage(res.error);
                        setDisplayWarning(true);
                    } else {
                        setConversionObj(res)
                        setDisplayCustomMarket(true);
                        setErrorMessage('')
                    }
                    message.destroy('conversion');
                })
            }else {
                message.destroy('conversion');
                message.error(a.error);
            }
        }))
    };

    const goBack = () => {
        if (step !== 0) {
            setStep(step - 1);
        } else {
            setDisplayRebalanceProfile(false);
        }
    }
    const onClickNext = async () => {

        if (displayCustomScript) {
            let scriptId;
            if (!selectedCustomScript || !scriptName) { message.error({ content: "Please fill the inputs" }); return; }
            if (displayCustomScript && selectedCustomScript === 'new') {
                try {
                    message.loading({ content: scriptLibraries.length > 0 ? 'Installing the libraries...' : 'Waiting...', key: 'scriptInstall', duration: 0 });
                    const script = await createScript({ script_name: scriptName, libraries: scriptLibraries, script: code })
                    message.destroy('scriptInstall');
                    if (script.error) {
                        message.error({ content: script.error })
                        return;
                    }
                    scriptId = script.createdScript.id
                    message.success({ content: "Changes Saved" });
                } catch (err) {
                    message.error({ content: err.message })
                    return;
                }
            } else if (selectedCustomScript && selectedCustomScript !== 'new') {
                message.loading({ content: scriptLibraries.length > 0 ? 'Updating the script...' : 'Waiting...', key: 'scriptInstall', duration: 0 });
                scriptId = selectedCustomScript
                const script = await updateScript({ id: scriptId, script_name: scriptName, libraries: scriptLibraries, script: code })
                message.destroy('scriptInstall');
                if (script.error) {
                    message.error({ content: script.error })
                    return;
                }
            }
            onChangeRebalanceProfile(newProfile, rebalanceSymbol, null, null, scriptId);
            setDisplayRebalanceProfile(false)
            return;
        }
        if (step !== 1) {
            if (!newProfile.exchange) {
                setOrderItem({ ...orderItem, rebalance_symbol: null, rebalance: null })
                setDisplayRebalanceProfile(false)
            } else {
                handleConnect();
            }
        } else {
            if (!profileBalance?.error) {
                if (!newProfile.exchange) {
                    setDisplayRebalanceProfile(false)
                } else {
                    onChangeRebalanceProfile(newProfile, rebalanceSymbol, null, null, null, { rebalanceOrderType, rebalanceSpread, firstAssetRebalance, secondAssetRebalance, rebalanceAssets })
                    setDisplayRebalanceProfile(false)
                }
            }
            else
            {
                message.error("Cannot proceed, There is a connection problem with the selected rebalance profile");
            }
        }

        // onChangeRebalanceProfile(rebalance, rebalanceSymbol)
    }
    const handleConnect = () => {
        setProfileLoading(true)
        newProfile.exchange = profile.exchange;
        setIsLoading(true);
        const isSandbox = newProfile && newProfile.is_sandbox;

        const selectedMarket = exchangeMarkets.find(x => x.id == `${profile.exchange}${newProfile.is_sandbox}`);
        if(selectedMarket && selectedMarket.date.getTime() + 1000 * 60 * 120 > new Date().getTime())
        {
            setMarkets(selectedMarket.markets);
            setIsLoading(false);
        }
        else { 
            fetchMarkets(newProfile.id).then(res => {
                if (Array.isArray(res)) {
                    setMarkets(res);
                    dispatch({ 
                        type: APP_ACTIONS.SET_MARKETS,
                        payload:{ id: `${profile.exchange}${newProfile.is_sandbox}`, markets: res, date: new Date() }
                    })
                }
                setIsLoading(false);
            }).catch(err => { setIsLoading(false); })
        }

        testProfile(newProfile).then(res => {
            console.log(res)
            delete res.info;

            let newArr = [];
            let hasTotal = false;

            Object.keys(res).forEach(key => {
                if (res?.[key]?.hasOwnProperty('total')) {
                    hasTotal = true;
                    newArr.push({ key, total: res?.[key]?.total })
                }
            })
            if (!hasTotal) {
                setProfileBalance(res);
            } else {
                setProfileBalance(newArr);
            }

            setProfileLoading(false);
        }).catch(err => {
            console.log({ err })
            setProfileLoading(false);
        })
        setStep(1);
    }

    const handleConnectToDEX = () => {
        if (step === 0) {
            setMarkets([]);
            setStep(1);
            setIsLoading(true);
            fetchUniswapPairs().then(res => {
                setIsLoading(false);
                if (Array.isArray(res)) {
                    setMarkets(res);
                }
            }).catch(err => { setIsLoading(false); console.log({ err }) })
        }
        else if (step === 1) {
            if (!customUniswapPair?.token1 || !customUniswapPair?.token2) {
                message.error({ content: "Please fill the fields" });
                return;
            }
            if (!selectedNetwork) {
                message.error({ content: "Please select network" });
                return;
            }
            onChangeRebalanceProfile(newProfile, null, customUniswapPair, selectedNetwork)
            setDisplayRebalanceProfile(false)
        }

    }

    const handleAssetRebalance = () => {
        let rebalanceData = {
            type: assetRebalanceInfo?.type,
            rebalance_profile: assetRebalanceInfo?.rebalance_profile,
            order_type: assetRebalanceInfo?.order_type,
            spread: assetRebalanceInfo?.spread,
            symbol: assetRebalanceInfo?.symbol,
            asset: assetRebalanceInfo?.asset,
            hasMarketConfig: assetRebalanceInfo?.hasMarketConfig,
            market_config: assetRebalanceInfo?.customMarketConfig
        }
        console.log({ assetRebalanceInfo: rebalanceData })

        setRebalanceAssets(previousState => {
            let newData = [...previousState];

            let foundIndex = newData.findIndex(x => x.type === assetRebalanceInfo.type);
            if (foundIndex > - 1) {
                if (assetRebalanceInfo?.rebalance_profile?.id && assetRebalanceInfo?.symbol) {
                    newData[foundIndex] = rebalanceData;
                } else {
                    newData.splice(foundIndex, 1);
                }
            } else {
                if (rebalanceData?.rebalance_profile?.id && assetRebalanceInfo?.symbol) newData.push(rebalanceData);
            }
            return newData;
        })
        if (assetRebalanceInfo.type === 'first_asset') {
            setFirstAssetRebalance(assetRebalanceInfo.symbol);
        } else {
            setSecondAssetRebalance(assetRebalanceInfo.symbol);
        }
        setAssetRebalanceInfo({
            type: null,
            rebalance_profile: null,
            order_type: null,
            spread: null,
            symbol: null,
            asset: null
        })
        setDisplaySubRebalance(false);
    }
    // Aliased assets (e.g. TON and GRAM) are the same asset, so compare normalized codes
    const [strategyBase, strategyQuote] = splitSymbol(orderItem?.symbol);
    const [selectedBase, selectedQuote] = splitSymbol(rebalanceSymbol);
    return (
        <Modal
            maskClosable={false}
            closeIcon={<CloseOutlined style={{ color: "white" }} />}
            bodyStyle={{
                backgroundColor: 'black',
                border: "1px solid grey"
            }}
            visible={displayRebalanceProfile} footer={null} onCancel={() => { setDisplayRebalanceProfile(false); }}>
            <div style={{ fontWeight: "600", color: "white" }}>
                <svg style={{ position: "relative", top: 3, marginRight: 5 }} xmlns="http://www.w3.org/2000/svg" width="21.101" height="21" viewBox="0 0 29.101 28">
                    <path id="Path_6006" data-name="Path 6006" d="M254.456,176.058a.865.865,0,0,0-.01-.1c-.006-.034-.014-.068-.023-.1a.553.553,0,0,0-.013-.054l-4.414-13.068c0-.01-.01-.02-.014-.03s-.016-.043-.027-.065-.018-.037-.028-.056-.021-.038-.033-.056-.021-.033-.033-.05-.026-.034-.04-.05-.03-.035-.044-.052l-.039-.038c-.015-.015-.033-.03-.05-.044s-.035-.028-.054-.041l-.048-.032c-.018-.011-.036-.022-.055-.032s-.039-.021-.059-.03-.041-.017-.062-.025-.02-.01-.031-.014l-.024-.005c-.021-.006-.042-.013-.065-.018s-.044-.009-.067-.012-.041-.007-.062-.009a.643.643,0,0,0-.067,0c-.011,0-.02,0-.031,0h-6.411a2.908,2.908,0,0,0-5.488,0h-6.411c-.011,0-.021,0-.032,0a.616.616,0,0,0-.065,0,.576.576,0,0,0-.062.01c-.023,0-.045.008-.068.013l-.063.017c-.008,0-.016,0-.024.005s-.02.01-.03.014l-.065.026-.058.03-.054.031c-.017.01-.034.021-.05.033l-.052.041c-.016.014-.033.027-.048.042l-.041.041c-.016.016-.03.033-.044.051s-.026.032-.039.049-.024.034-.035.052-.021.036-.032.056a.543.543,0,0,0-.027.054c-.01.021-.019.044-.027.067s-.01.019-.014.03L225.409,175.8c-.006.018-.007.036-.012.054a.9.9,0,0,0-.024.1.861.861,0,0,0-.01.1c0,.019-.006.038-.006.057v1.907a2.837,2.837,0,0,0,2.834,2.834h5.122a2.837,2.837,0,0,0,2.834-2.834v-1.907c0-.02,0-.039-.006-.057a.815.815,0,0,0-.01-.1.858.858,0,0,0-.024-.1c0-.018-.006-.036-.012-.054l-3.977-11.773h5.044a2.923,2.923,0,0,0,1.763,1.763v20.369H232.59a.981.981,0,0,0,0,1.961h14.631a.981.981,0,1,0,0-1.961h-6.336V165.79a2.922,2.922,0,0,0,1.764-1.763h5.044L243.717,175.8c-.006.018-.008.036-.013.055-.009.033-.017.067-.023.1a.859.859,0,0,0-.01.1c0,.019-.006.037-.006.056v1.907a2.837,2.837,0,0,0,2.834,2.834h5.122a2.837,2.837,0,0,0,2.834-2.834v-1.907a.115.115,0,0,0,0-.056Zm-2.341-.925H246.02l3.048-9.023Zm-12.2-13.052a.964.964,0,1,1-.964.963A.965.965,0,0,1,239.912,162.082Zm-9.155,4.028,3.048,9.023h-6.095Zm3.433,11.911a.874.874,0,0,1-.872.872H228.2a.874.874,0,0,1-.872-.872V177.1h6.867Zm18.309,0a.874.874,0,0,1-.872.872h-5.122a.874.874,0,0,1-.872-.872V177.1H252.5Z" transform="translate(-225.357 -160.124)" fill="#fff" />
                </svg>

                Platform rebalance profile</div>
            <div style={{ color: "grey", marginTop: 10 }}>Select the exchange profile for rebalancing and the market.</div>
            {step === 0 ?
                <>
                    <div style={{ color: "white", margin: "30px 0" }}>
                        <label>Exchange API Profile</label>
                        <Select
                            value={profile.exchange || (displayCustomScript ? 'Custom Script' : 'None')} onChange={(value) => {
                                setNewProfile({
                                    name: null,
                                    exchange: null,
                                    api_key: null,
                                    api_secret: null,
                                    ...(value === 'hollaex' && { custom_api_url: 'https://api.hollaex.com' }),
                                    ...(value === 'hollaex' && { custom_websocket_url: 'wss://api.hollaex.com/stream' }),
                                    is_sandbox: false,
                                });
                                setDisplayCustomScript(false);
                                if (!value) {
                                    setProfile({})
                                } else {
                                    if (value === 'Custom Script') {
                                        setDisplayCustomScript(true);
                                        setProfile({})
                                    } else {
                                        setProfile({ ...profile, exchange: value })
                                    }
                                }
                            }}
                            style={{ width: "100%", marginTop: 10 }}
                            placeholder="Select profile"

                        >
                            <Option value={null}>None</Option>
                            {exchanges.map(x => <Option value={x.value}>{x.label}</Option>)}
                        </Select>
                    </div>

                    {displayCustomScript ?
                        <div style={{ color: "white", marginBottom: 50, marginTop: 15 }}>
                            <label>Saved Scripts</label>
                            <Select
                                showSearch
                                value={customScripts?.find(script => script.id === selectedCustomScript)?.script_name}
                                placeholder="Select a script"
                                style={{ color: "black", width: "100%" }}
                                notFoundContent={'Not Found'}
                                onChange={(value) => {
                                    setScriptLibraries([]);
                                    setScriptName();
                                    setCode(defaultCode)

                                    const script = customScripts?.find(script => script.id === value)
                                    if (script) {
                                        if (Array.isArray(script.libraries)) {
                                            setScriptLibraries([...script.libraries]);
                                        } else {
                                            setScriptLibraries([]);
                                        }
                                        setScriptName(script.script_name);
                                        setCode(script.script)
                                    }

                                    setSelectedCustomScript(value)
                                }}
                            >
                                <Option value={'new'}>New</Option>
                                {customScripts.map(script => <Option value={script.id}>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        }}
                                    >
                                        <div>{script.script_name}</div>

                                        <Popconfirm

                                            title="Are you sure to delete this script?"
                                            onConfirm={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                handleDeleteScript(script.id);

                                            }}
                                            onCancel={() => { }}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Button
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();

                                                }}
                                                danger size="small">
                                                Delete
                                            </Button>
                                        </Popconfirm>

                                    </div>
                                </Option>)}

                            </Select>
                            <>
                                <div style={{ marginBottom: 20, marginTop: 20 }}>
                                    <label>Script Name</label>
                                    <TextArea value={scriptName} onChange={(e) => { setScriptName(e.target.value) }} style={{ marginTop: 10 }} placeholder="Enter Script Name" rows={1} />
                                </div>

                                <div style={{ marginBottom: 20 }}>
                                    <label>Libraries to install</label>
                                    <Select
                                        mode="tags"
                                        value={scriptLibraries}
                                        style={{
                                            width: '100%',
                                            marginTop: 10
                                        }}
                                        placeholder="Add libraries that your script requires if any"
                                        onChange={(value) => { setScriptLibraries(value); }}
                                    >
                                        {["lodash@4.17.21"].map(lib => <Option key={lib}>{lib}</Option>)}
                                    </Select>
                                    <div style={{ fontStyle: "italic", fontSize: 13, marginTop: 2 }}>You can also define version when adding a library, e.g: lodash@4.17.21 </div>
                                    <div style={{ fontStyle: "italic", fontSize: 13, marginTop: 10 }}>You can access the libraries you installed by the following way in the script, e.g. const lodash = installedLibraries['lodash'];</div>
                                    <div style={{ fontStyle: "italic", fontSize: 13, marginTop: 10 }}>You can access the trade info of the filled order by the following way in the script  e.g. trade.symbol, trade.amount, trade.side and trade.price</div>
                                </div>

                                <div style={{ marginBottom: 20 }}>
                                    <label>Script Code</label>
                                    <CodeEditor
                                        value={code}
                                        language="js"
                                        placeholder="Please enter JS code."
                                        onChange={(evn) => setCode(evn.target.value)}
                                        padding={15}
                                        style={{
                                            minHeight: 300,
                                            fontSize: 12,
                                            border: "1px solid grey",
                                            backgroundColor: "#0D1117",
                                            fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
                                        }}
                                    />
                                </div>
                            </>

                        </div> :
                        <div style={{ color: "white", marginTop: 30, marginBottom: 10 }}>
                            <label>Select profile</label>
                            <Select
                                value={newProfile?.name || 'new'}
                                onChange={(value) => {
                                    if (value === 'new') {
                                        setCreateAction(true);
                                        setNewProfile({
                                            name: null,
                                            exchange: null,
                                            api_key: null,
                                            api_secret: null,
                                            ...(profile.exchange === 'hollaex' && { custom_api_url: 'https://api.hollaex.com' }),
                                            ...(profile.exchange === 'hollaex' && { custom_websocket_url: 'wss://api.hollaex.com/stream' }),
                                        });
                                    } else {
                                        const foundProfile = profiles.find(profile => profile.id === value);
                                        setNewProfile(foundProfile);
                                        setCreateAction(false);
                                    }

                                }}
                                style={{ width: "100%", marginTop: 10 }}
                                placeholder="Select profile"

                            >
                                <Option value="new">New</Option>
                                {profiles.map(x => {
                                    if (x.exchange === profile.exchange) {
                                        return <Option value={x.id}>{x.name}</Option>
                                    }
                                })}
                            </Select>
                        </div>
                    }

                    {(profile.exchange && createAction) && <div style={{ color: "white", marginBottom: 30, padding: 10, marginTop: 20 }}>
                        <div style={{ border: "1px solid grey", width: "100%", padding: "0 20px" }}>
                            <h1 style={{ width: 250, textAlign: "center", fontSize: 14, marginTop: -10, marginLeft: -10, backgroundColor: "black", color: "white" }}>New {exchanges.find(x => x.value === profile.exchange).label} exchange API profile</h1>
                            <div style={{ color: "white", marginTop: 10 }}>
                                <label>Name</label>
                                <Input value={newProfile.name} onChange={(e) => { setNewProfile({ ...newProfile, name: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Name" />
                            </div>

                            {Object.keys(exchangesWithParams).includes(profile.exchange) ?
                                <>
                                    {exchangesWithParams[profile.exchange].type === 'only' ? <></> :
                                        <>
                                            <div style={{ color: "white", margin: "30px 0" }}>
                                                <label>API key</label>
                                                <Input value={newProfile.api_key} onChange={(e) => { setNewProfile({ ...newProfile, api_key: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input API key" />
                                            </div>
                                            <div style={{ color: "white" }}>
                                                <label>API secret</label>
                                                <Input value={newProfile.api_secret} onChange={(e) => { setNewProfile({ ...newProfile, api_secret: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input API secret" />
                                            </div>

                                        </>
                                    }
                                </> :
                                <>
                                    <div style={{ color: "white", margin: "30px 0" }}>
                                        <label>API key</label>
                                        <Input value={newProfile.api_key} onChange={(e) => { setNewProfile({ ...newProfile, api_key: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input API key" />
                                    </div>
                                    <div style={{ color: "white" }}>
                                        <label>API secret</label>
                                        <Input value={newProfile.api_secret} onChange={(e) => { setNewProfile({ ...newProfile, api_secret: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input API secret" />
                                    </div>

                                </>

                            }

                            {Object.keys(exchangesWithParams).includes(profile.exchange) &&
                                <div style={{ color: "white", marginTop: 30 }}>
                                    <label>{exchangesWithParams[profile.exchange].label}</label>
                                    <Input value={newProfile[exchangesWithParams[profile.exchange].param]} onChange={(e) => { setNewProfile({ ...newProfile, [exchangesWithParams[profile.exchange].param]: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input Password" />
                                </div>
                            }
                            {profile.exchange === 'hollaex' && <div style={{ color: "white", margin: "30px 0" }}>
                                <label>Custom API Url (Optional)</label>
                                <Input value={newProfile.custom_api_url} onChange={(e) => { setNewProfile({ ...newProfile, custom_api_url: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input Custom Url" />
                            </div>}
                            {profile.exchange === 'hollaex' && <div style={{ color: "white", margin: "30px 0" }}>
                                <label>Custom Websocket Url (Optional)</label>
                                <Input value={newProfile.custom_websocket_url} onChange={(e) => { setNewProfile({ ...newProfile, custom_websocket_url: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input Custom Url" />
                            </div>}

                            {!dex.includes(profile.exchange) &&
                                <div style={{ color: "white", marginTop: 15 }}>
                                    <Checkbox checked={newProfile.is_sandbox} style={{ color: "white" }} onChange={(e) => {
                                        setNewProfile({
                                            ...newProfile,
                                            is_sandbox: e.target.checked,
                                            ...(profile.exchange === 'hollaex' && { custom_api_url: e.target.checked ? 'https://api.sandbox.hollaex.com' : 'https://api.hollaex.com' }),
                                            ...(profile.exchange === 'hollaex' && { custom_websocket_url: e.target.checked ? 'wss://api.sandbox.hollaex.com/stream' : 'wss://api.hollaex.com/stream' }),
                                        })
                                    }}>Sandbox mode </Checkbox>
                                </div>
                            }

                            <div style={{ color: "white", cursor: "pointer", display: "flex", justifyContent: "flex-end", flexDirection: "row", padding: "10px 0", marginTop: 15 }}>
                                {!dex.includes(profile.exchange) &&
                                    <span onClick={() => { handleConnect() }} style={{ textDecoration: "underline" }} >CONNECT</span>
                                }
                            </div>
                        </div>
                    </div>}
                </>
                :
                <>
                    {/* {!dex.includes(profile.exchange) &&
                        <div style={{ color: "white", marginTop: 20, padding: 10 }}>
                            <div style={{ color: "white", marginBottom: 30, padding: 10 }}>
                                <div style={{ border: "1px solid grey", width: "100%", maxHeight: 400, padding: "0 20px" }}>
                                    <h1 style={{ width: 200, textAlign: "center", fontSize: 14, marginTop: -10, marginLeft: -10, backgroundColor: "black", color: "white" }}>{exchanges.find(x => x.value === newProfile.exchange).label} Balance</h1>
                                    <div style={{ overflowY: "auto", height: 300, marginTop: 10 }}>
                                        {profileLoading && <Spin size="large" />}
                                        {profileBalance && Array.isArray(profileBalance) ?
                                            profileBalance.sort((a, b) => b.total - a.total).map(data => <div style={{ display: "flex", flexDirection: "row", gap: 5, marginBottom: 5 }}>
                                                <div>{data.key}:</div>
                                                <div>{data.total}</div>
                                            </div>)
                                            : profileBalance && Object.keys(profileBalance).map(key => <>
                                                <div>{key}:</div>
                                                <div>{JSON.stringify(profileBalance[key])}</div>
                                            </>)}

                                    </div>
                                </div>
                            </div>
                        </div>
                    } */}

                    <div style={{
                        color: "white", marginBottom: 50,
                        marginTop: 30
                        // marginTop: dex.includes(profile.exchange) ? 30 : 0
                    }}>
                        {!dex.includes(profile.exchange) ? <>


                            <label>Market symbol to rebalance from</label>
                            <div>
                                <Select
                                    showSearch
                                    placeholder="Rebalance symbol"
                                    value={rebalanceSymbol || null}
                                    style={{ color: "black", width: "100%" }}
                                    notFoundContent={isLoading ? <Spin size="small" /> : null}
                                    onChange={(value) => {
                                        const [valueBase, valueQuote] = splitSymbol(value);
                                        if (!isSameAsset(strategyBase, valueBase) &&
                                            !isSameAsset(strategyQuote, valueQuote)) {
                                            message.error("Can't rebalance with assets that are completely different from the strategy's market ");
                                            return;
                                        }
                                        setRebalanceSymbol(value);
                                        setFirstAssetRebalance();
                                        setSecondAssetRebalance();
                                        if (isSameAsset(strategyBase, valueBase) &&
                                            !isSameAsset(strategyQuote, valueQuote)) {
                                            setFirstAssetRebalance(value)
                                        }

                                        if (isSameAsset(strategyQuote, valueQuote) &&
                                            !isSameAsset(strategyBase, valueBase)) {
                                            setSecondAssetRebalance(value)
                                        }

                                    }}
                                >
                                    {markets.map(market => <Option value={market.symbol}>{market.symbol}</Option>)}

                                </Select>
                            </div>

                            {(
                                (isSameAsset(strategyBase, selectedBase) &&
                                    !isSameAsset(strategyQuote, selectedQuote))
                                || (isSameAsset(strategyQuote, selectedQuote) &&
                                    !isSameAsset(strategyBase, selectedBase))) &&
                                <>
                                    <div style={{ marginTop: 15, fontWeight: "bold" }}>You selected a different market than the strategy's market, the selected profile in the previous step will be overridden. You can configure the settings of both assets below.</div>
                                    <div style={{ marginTop: 20 }}>
                                        Select rebalance market for asset: {orderItem?.symbol?.split('/')[0]} (Optional)

                                        <div>
                                            {/* <Select
                                                onClick={() => {
                                                    setDisplaySubRebalance(true);
                                                    setAssetRebalanceInfo({ ...assetRebalanceInfo, type: 'first_asset', asset: orderItem?.symbol?.split('/')[0] })
                                                }}
                                                showSearch
                                                placeholder="Rebalance symbol"
                                                value={firstAssetRebalance}
                                                style={{ color: "black", width: "100%" }}
                                                notFoundContent={isLoading ? <Spin size="small" /> : null}
                                                onChange={(value) => { setFirstAssetRebalance(value) }}
                                            >
                                                <Option value={null}>None</Option>
                                                {markets.map(market => {

                                                    if (market?.symbol?.split('/')?.indexOf((orderItem?.symbol?.split('/')[0])) > -1) {
                                                        return <Option value={market.symbol}>{market.symbol}</Option>
                                                    }
                                                })}

                                            </Select> */}

                                            <Input
                                                onClick={() => {
                                                    setDisplaySubRebalance(true);

                                                    let foundRebalanceConfig = rebalanceAssets?.find(x => x.type === 'first_asset');
                                                    if (foundRebalanceConfig) {
                                                        foundRebalanceConfig.customMarketConfig = foundRebalanceConfig?.market_config; setSubRebalanceProfile({ ...subRebalanceProfile, exchange: foundRebalanceConfig?.rebalance_profile?.exchange })
                                                    }
                                                    setAssetRebalanceInfo({ ...assetRebalanceInfo, type: 'first_asset', order_type: 'market', symbol: firstAssetRebalance, asset: orderItem?.symbol?.split('/')[0], ...foundRebalanceConfig })

                                                }}
                                                placeholder="Rebalance symbol"
                                                style={{ color: "black", width: "100%" }}
                                                value={rebalanceAssets?.find(x => x.type === 'first_asset')?.symbol}
                                            />

                                        </div>
                                    </div>
                                    <div style={{ marginTop: 20 }}>
                                        Select rebalance market for asset: {orderItem?.symbol?.split('/')[1]} (Optional)

                                        <div>
                                            {/* <Select
                                                showSearch
                                                placeholder="Rebalance symbol"
                                                value={secondAssetRebalance}
                                                style={{ color: "black", width: "100%" }}
                                                notFoundContent={isLoading ? <Spin size="small" /> : null}
                                                onChange={(value) => { setSecondAssetRebalance(value) }}
                                            >
                                                <Option value={null}>None</Option>
                                                {markets.map(market => {
                                                    if (market?.symbol?.split('/')?.indexOf((orderItem?.symbol?.split('/')[1])) > -1) {
                                                        return <Option value={market.symbol}>{market.symbol}</Option>
                                                    }
                                                })}

                                            </Select> */}
                                            <Input
                                                onClick={() => {
                                                    setDisplaySubRebalance(true);
                                                    let foundRebalanceConfig = rebalanceAssets?.find(x => x.type === 'second_asset');
                                                    if (foundRebalanceConfig) {
                                                        foundRebalanceConfig.customMarketConfig = foundRebalanceConfig?.market_config; setSubRebalanceProfile({ ...subRebalanceProfile, exchange: foundRebalanceConfig?.rebalance_profile?.exchange })
                                                    }
                                                    setAssetRebalanceInfo({ ...assetRebalanceInfo, type: 'second_asset', order_type: 'market', symbol: secondAssetRebalance, asset: orderItem?.symbol?.split('/')[1], ...foundRebalanceConfig })
                                                }}
                                                placeholder="Rebalance symbol"
                                                style={{ color: "black", width: "100%" }}
                                                value={rebalanceAssets?.find(x => x.type === 'second_asset')?.symbol}
                                            />

                                        </div>
                                    </div>
                                </>
                            }

                            {(isSameAsset(strategyBase, selectedBase) &&
                                isSameAsset(strategyQuote, selectedQuote)) &&
                                <div style={{ marginBottom: 20, marginTop: 20 }}>
                                    <Radio.Group onChange={(e) => { setRebalanceOrderType(e.target.value) }} value={rebalanceOrderType}>
                                        <Space direction="vertical">
                                            <Radio style={{ color: "white" }} value={'market'}>Market Order</Radio>
                                            <Radio style={{ color: "white" }} value={'limit'}>Limit Order

                                                {rebalanceOrderType === 'limit' ? <span><Input value={rebalanceSpread} onChange={(e) => { setRebalanceSpread(e.target.value) }} placeholder="Spread%" style={{ width: 100, marginLeft: 20 }} /> <span></span> </span> : null}</
                                            Radio>
                                        </Space>
                                    </Radio.Group>

                                </div>
                            }
                            {displaySubRebalance && <>
                                <Modal
                                    maskClosable={false}
                                    closeIcon={<CloseOutlined style={{ color: "white" }} />}
                                    bodyStyle={{
                                        backgroundColor: 'black',
                                        border: "1px solid grey"
                                    }}
                                    style={{ marginTop: 50 }}
                                    visible={displaySubRebalance} footer={null} onCancel={() => { setDisplaySubRebalance(false); }}>
                                    <div style={{ fontWeight: "600", color: "white" }}>Configure rebalance profile for:</div>
                                    <div>

                                        <div style={{ color: "white", margin: "30px 0" }}>
                                            <label>Exchange</label>
                                            <Select
                                                value={subRebalanceProfile?.exchange || 'None'} onChange={(value) => {

                                                    if (!value) {
                                                        setSubRebalanceProfile({})
                                                        setAssetRebalanceInfo({ ...assetRebalanceInfo, rebalance_profile: null, createAction: false })
                                                        return;

                                                    }
                                                    setAssetRebalanceInfo({
                                                        ...assetRebalanceInfo,
                                                        rebalance_profile: {
                                                            exchange: value,
                                                            ...(value === 'hollaex' && { custom_api_url: 'https://api.hollaex.com' }),
                                                            ...(value === 'hollaex' && { custom_websocket_url: 'wss://api.hollaex.com/stream' }),
                                                        },
                                                        createAction: true, hasMarketConfig: false, customMarketConfig: null
                                                    })

                                                    setSubRebalanceProfile({ ...subRebalanceProfile, exchange: value })
                                                }}
                                                style={{ width: "100%", marginTop: 10 }}
                                                placeholder="Select Exchange"

                                            >
                                                <Option value={null}>None</Option>
                                                {exchanges.map(x => {
                                                    if (x.value !== 'Custom Script' && x.value !== 'uniswap') {
                                                        return <Option value={x.value}>{x.label}</Option>
                                                    }
                                                })}
                                            </Select>
                                        </div>

                                    </div>

                                    <div style={{ color: "white", marginTop: 30, marginBottom: 20 }}>
                                        <label>Select profile</label>
                                        <Select
                                            value={assetRebalanceInfo?.createAction ? 'new' : assetRebalanceInfo?.rebalance_profile?.name}
                                            onChange={(value) => {
                                                if (value === 'new') {
                                                    setAssetRebalanceInfo({
                                                        ...assetRebalanceInfo, rebalance_profile: {
                                                            exchange: subRebalanceProfile.exchange,
                                                            ...(subRebalanceProfile.exchange === 'hollaex' && { custom_api_url: 'https://api.hollaex.com' }),
                                                            ...(subRebalanceProfile.exchange === 'hollaex' && { custom_websocket_url: 'wss://api.hollaex.com/stream' }),
                                                        }, createAction: true, hasMarketConfig: false, customMarketConfig: null
                                                    })
                                                }
                                                else {
                                                    const foundProfile = profiles.find(profile => profile.id === value);

                                                    setAssetRebalanceInfo({ ...assetRebalanceInfo, rebalance_profile: foundProfile, createAction: false, hasMarketConfig: false, customMarketConfig: null })

                                                    fetchMarkets(foundProfile.id).then(res => {
                                                        if (Array.isArray(res)) {
                                                            setAssetRebalanceInfo({ ...assetRebalanceInfo, rebalance_profile: foundProfile, markets: res, createAction: false, hasMarketConfig: false, customMarketConfig: null })
                                                        }
                                                    })
                                                }


                                            }}
                                            style={{ width: "100%", marginTop: 10 }}
                                            placeholder="Select Profile"

                                        >
                                            <Option value="new">New</Option>
                                            {profiles.map(x => {
                                                if (x.exchange === subRebalanceProfile?.exchange) {
                                                    return <Option value={x.id}>{x.name}</Option>
                                                }
                                            })}
                                        </Select>
                                    </div>

                                    {assetRebalanceInfo?.createAction && <div style={{ color: "white", marginBottom: 30, padding: 10, marginTop: 20 }}>
                                        <div style={{ border: "1px solid grey", width: "100%", padding: "0 20px" }}>
                                            <h1 style={{ width: 250, textAlign: "center", fontSize: 14, marginTop: -10, marginLeft: -10, backgroundColor: "black", color: "white" }}>New {exchanges.find(x => x.value === profile.exchange).label} exchange API profile</h1>
                                            <div style={{ color: "white", marginTop: 10 }}>
                                                <label>Name</label>
                                                <Input value={assetRebalanceInfo?.rebalance_profile?.name} onChange={(e) => {
                                                    setAssetRebalanceInfo({
                                                        ...assetRebalanceInfo, rebalance_profile: {
                                                            ...assetRebalanceInfo.rebalance_profile,
                                                            name: e.target.value
                                                        }
                                                    })

                                                }} style={{ marginTop: 10 }} placeholder="Name" />
                                            </div>

                                            {Object.keys(exchangesWithParams).includes(subRebalanceProfile.exchange) ?
                                                <>
                                                    {exchangesWithParams[subRebalanceProfile.exchange].type === 'only' ? <></> :
                                                        <>
                                                            <div style={{ color: "white", margin: "30px 0" }}>
                                                                <label>API key</label>
                                                                <Input value={assetRebalanceInfo?.rebalance_profile?.api_key} onChange={(e) => {

                                                                    setAssetRebalanceInfo({
                                                                        ...assetRebalanceInfo, rebalance_profile: {
                                                                            ...assetRebalanceInfo.rebalance_profile,
                                                                            api_key: e.target.value
                                                                        }
                                                                    })
                                                                }} style={{ marginTop: 10 }} placeholder="Input API key" />
                                                            </div>
                                                            <div style={{ color: "white" }}>
                                                                <label>API secret</label>
                                                                <Input value={assetRebalanceInfo?.rebalance_profile?.api_secret} onChange={(e) => {

                                                                    setAssetRebalanceInfo({
                                                                        ...assetRebalanceInfo, rebalance_profile: {
                                                                            ...assetRebalanceInfo.rebalance_profile,
                                                                            api_secret: e.target.value
                                                                        }
                                                                    })
                                                                }} style={{ marginTop: 10 }} placeholder="Input API secret" />
                                                            </div>

                                                        </>
                                                    }
                                                </> :
                                                <>
                                                    <div style={{ color: "white", margin: "30px 0" }}>
                                                        <label>API key</label>
                                                        <Input value={assetRebalanceInfo?.rebalance_profile?.api_key} onChange={(e) => {

                                                            setAssetRebalanceInfo({
                                                                ...assetRebalanceInfo, rebalance_profile: {
                                                                    ...assetRebalanceInfo.rebalance_profile,
                                                                    api_key: e.target.value
                                                                }
                                                            })
                                                        }} style={{ marginTop: 10 }} placeholder="Input API key" />
                                                    </div>
                                                    <div style={{ color: "white" }}>
                                                        <label>API secret</label>
                                                        <Input value={assetRebalanceInfo?.rebalance_profile?.api_secret} onChange={(e) => {
                                                            setAssetRebalanceInfo({
                                                                ...assetRebalanceInfo, rebalance_profile: {
                                                                    ...assetRebalanceInfo.rebalance_profile,
                                                                    api_secret: e.target.value
                                                                }
                                                            })
                                                        }} style={{ marginTop: 10 }} placeholder="Input API secret" />
                                                    </div>

                                                </>

                                            }

                                            {/* {Object.keys(exchangesWithParams).includes(subRebalanceProfile.exchange) &&
                                                <div style={{ color: "white", marginTop: 30 }}>
                                                    <label>{exchangesWithParams[subRebalanceProfile.exchange].label}</label>
                                                    <Input value={newProfile[exchangesWithParams[subRebalanceProfile.exchange].param]} onChange={(e) => { setNewProfile({ ...newProfile, [exchangesWithParams[subRebalanceProfile.exchange].param]: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input Password" />
                                                </div>
                                            } */}
                                            {subRebalanceProfile.exchange === 'hollaex' && <div style={{ color: "white", margin: "30px 0" }}>
                                                <label>Custom API Url (Optional)</label>
                                                <Input value={assetRebalanceInfo?.rebalance_profile?.custom_api_url} onChange={(e) => {
                                                    setAssetRebalanceInfo({
                                                        ...assetRebalanceInfo, rebalance_profile: {
                                                            ...assetRebalanceInfo.rebalance_profile,
                                                            custom_api_url: e.target.value
                                                        }
                                                    })

                                                }} style={{ marginTop: 10 }} placeholder="Input Custom Url" />
                                            </div>}
                                            {subRebalanceProfile.exchange === 'hollaex' && <div style={{ color: "white", margin: "30px 0" }}>
                                                <label>Custom Websocket Url (Optional)</label>
                                                <Input value={assetRebalanceInfo?.rebalance_profile?.custom_websocket_url} onChange={(e) => {

                                                    setAssetRebalanceInfo({
                                                        ...assetRebalanceInfo, rebalance_profile: {
                                                            ...assetRebalanceInfo.rebalance_profile,
                                                            custom_websocket_url: e.target.value
                                                        }
                                                    })
                                                }} style={{ marginTop: 10 }} placeholder="Input Custom Url" />
                                            </div>}

                                            <div style={{ color: "white", marginTop: 15 }}>
                                                <Checkbox checked={assetRebalanceInfo?.rebalance_profile?.is_sandbox} style={{ color: "white" }} onChange={(e) => {

                                                    setAssetRebalanceInfo({
                                                        ...assetRebalanceInfo, rebalance_profile: {
                                                            ...assetRebalanceInfo.rebalance_profile,
                                                            is_sandbox: e.target.checked,
                                                            ...(subRebalanceProfile.exchange === 'hollaex' && { custom_api_url: e.target.checked ? 'https://api.sandbox.hollaex.com' : 'https://api.hollaex.com' }),
                                                            ...(subRebalanceProfile.exchange === 'hollaex' && { custom_websocket_url: e.target.checked ? 'wss://api.sandbox.hollaex.com/stream' : 'wss://api.hollaex.com/stream' }),
                                                        }
                                                    })
                                                }}>Sandbox mode </Checkbox>
                                            </div>

                                            <div style={{ color: "white", cursor: "pointer", display: "flex", justifyContent: "flex-end", flexDirection: "row", padding: "10px 0", marginTop: 15 }}>
                                                <span onClick={() => {
                                                    setSubprofileLoading(true)
                                                    message.loading({ content: 'Waiting...', key: 'subprofileCreation', duration: 0 });
                                                    testProfile(assetRebalanceInfo?.rebalance_profile).then(res => {
                                                        console.log(res)
                                                        delete res.info;

                                                        let newArr = [];
                                                        let hasTotal = false;

                                                        Object.keys(res).forEach(key => {
                                                            if (res?.[key]?.hasOwnProperty('total')) {
                                                                hasTotal = true;
                                                                newArr.push({ key, total: res?.[key]?.total })
                                                            }
                                                        })
                                                        if (!hasTotal) {
                                                            setSubprofileBalance(res);
                                                        } else {
                                                            setSubprofileBalance(newArr);
                                                        }

                                                        createProfile(assetRebalanceInfo?.rebalance_profile).then((newProfileData) => {
                                                            if (newProfileData.error) {
                                                                message.error(newProfileData.error);
                                                                message.destroy('subprofileCreation');
                                                                setSubprofileLoading(false);
                                                                return;

                                                            }

                                                            fetchProfiles().then(res => {
                                                                dispatch({
                                                                    type: APP_ACTIONS.SET_PROFILES,
                                                                    payload: res,
                                                                })
                                                                fetchMarkets(newProfileData.id).then(res => {
                                                                    if (Array.isArray(res)) {
                                                                        setAssetRebalanceInfo({
                                                                            ...assetRebalanceInfo, markets: res,
                                                                            rebalance_profile: {
                                                                                ...assetRebalanceInfo.rebalance_profile,
                                                                                id: newProfileData.id
                                                                            },
                                                                            createAction: false
                                                                        })
                                                                        message.success("Profile Saved")
                                                                    }
                                                                    message.destroy('subprofileCreation');
                                                                })

                                                            })
                                                        })

                                                        setSubprofileLoading(false);
                                                    }).catch(err => {
                                                        console.log({ err })
                                                        message.error({ content: err.message })
                                                        message.destroy('subprofileCreation');
                                                        setSubprofileLoading(false);
                                                    })

                                                }} style={{ textDecoration: "underline" }} >CONNECT & ADD</span>
                                            </div>
                                        </div>
                                    </div>}

                                    {(assetRebalanceInfo?.rebalance_profile && !assetRebalanceInfo.createAction) &&
                                        <>
                                            <div style={{ marginBottom: 20 }}>
                                                <Radio.Group onChange={(e) => {
                                                    setAssetRebalanceInfo({ ...assetRebalanceInfo, order_type: e.target.value })
                                                }} value={assetRebalanceInfo?.order_type}>
                                                    <Space direction="vertical">
                                                        <Radio style={{ color: "white" }} value={'market'}>Market Order</Radio>
                                                        <Radio style={{ color: "white" }} value={'limit'}>Limit Order

                                                            {assetRebalanceInfo?.order_type === 'limit' ? <Input
                                                                value={assetRebalanceInfo?.spread}
                                                                onChange={(e) => {
                                                                    setAssetRebalanceInfo({ ...assetRebalanceInfo, spread: e.target.value })
                                                                }} placeholder="Spread%" style={{ width: 100, marginLeft: 20 }} /> : null}</
                                                        Radio>
                                                    </Space>
                                                </Radio.Group>

                                            </div>

                                            <div style={{ marginBottom: 10 }}>
                                                <Select
                                                    showSearch
                                                    placeholder="Rebalance symbol"
                                                    value={assetRebalanceInfo?.symbol}
                                                    style={{ color: "black", width: "100%" }}
                                                    notFoundContent={isLoading ? <Spin size="small" /> : null}
                                                    onFocus={() => {
                                                        if (!assetRebalanceInfo?.markets) {
                                                            fetchMarkets(assetRebalanceInfo?.rebalance_profile?.id).then(res => {
                                                                if (Array.isArray(res)) {
                                                                    setAssetRebalanceInfo({ ...assetRebalanceInfo, markets: res })
                                                                }
                                                            })
                                                        }
                                                    }}
                                                    onChange={(value) => {

                                                        // message.loading({ content: 'finding conversion...', key: 'conversion', duration: 0 });
                                                        // calculateConversion({
                                                        //     exchangeId: orderItem?.source,
                                                        //     selectedSymbol: orderItem?.symbol,
                                                        //     marketFocus: value,
                                                        //     userId,
                                                        //     isSandbox: orderItem?.isSandbox,
                                                        //     isRebalance: true,
                                                        //     conversion: orderItem?.conversionMarket,
                                                        //     sourceSymbol: orderItem?.source_symbol
                                                        // }).then(res => {
                                                        //     if (res.error) {
                                                        //         setErrorMessage(res.error);
                                                        //         setDisplayWarning(true);
                                                        //     } else {
                                                        //         setConversionObj(res)
                                                        //         setDisplayCustomMarket(true);
                                                        //         setErrorMessage('')
                                                        //     }
                                                        //     message.destroy('conversion');
                                                        // })

                                                        setAssetRebalanceInfo({ ...assetRebalanceInfo, symbol: value, hasMarketConfig: false, customMarketConfig: null })

                                                    }}
                                                >
                                                    <Option value={null}>None</Option>
                                                    {assetRebalanceInfo?.markets?.map(market => {

                                                        const [marketBase, marketQuote] = splitSymbol(market?.symbol);
                                                        if (isSameAsset(marketBase, assetRebalanceInfo.asset) ||
                                                            isSameAsset(marketQuote, assetRebalanceInfo.asset)) {
                                                            return <Option value={market.symbol}>{market.symbol}</Option>
                                                        }
                                                    })}

                                                </Select>
                                            </div>

                                            {displayCustomMarket && <Modal
                                                maskClosable={false}
                                                closeIcon={<CloseOutlined style={{ color: "white" }} />}
                                                bodyStyle={{
                                                    backgroundColor: 'black',
                                                    border: "1px solid grey"
                                                }}
                                                // style={{ marginTop: 40 }}
                                                visible={displayCustomMarket} footer={null} onCancel={() => { setDisplayCustomMarket(false); }}>

                                                <div style={{ fontWeight: "600", color: "white" }}>
                                                    {errorMessage ? <span><WarningOutlined /> Different Market Warning </span> : 'Market Conversion'}


                                                </div>
                                                <div style={{ color: "white", marginTop: 20, marginBottom: 40 }}>
                                                    {errorMessage ? `Conversion not found for the selected market` :
                                                        <div>
                                                         <div>Conversion found using the market <span style={{ fontWeight: 'bold' }}>{conversionObj?.customConfig?.symbol}</span> from the config</div>
                                                         <div>{conversionObj?.customConfig?.symbol} price: <span style={{ fontWeight: 'bold' }}>{conversionObj?.customConfig?.price}</span></div>
                                                         <div>Converted price : {!conversionObj?.newPrice?.toString()?.startsWith("0") ? <span style={{ fontWeight: 'bold' }}>{conversionObj?.newPrice?.toFixed(4)}</span> : <span style={{ fontWeight: 'bold' }}>{conversionObj?.newPrice}</span>}</div>
                         
                                                         <div style={{ fontWeight: 'bold', marginTop: 15, marginBottom: 10 }}>If you wish to proceed, this conversion will be applied. Alternatively you can also select the {conversionObj?.customConfig?.symbol} price from below exchanges <span style={{ fontWeight: 'bold', color: 'red', textDecoration: 'underline' }}>which will override your pirce fom the config.</span>  </div>
                                                         
                                                         <Select
                                                             showSearch
                                                             style={{ width: 300 }}
                                                             placeholder="Search and select an exchange"
                                                             optionFilterProp="children"
                                                             onChange={handleChange}
                                                             filterOption={(input, option) =>
                                                                 option.children.toLowerCase().includes(input.toLowerCase())
                                                             }
                                                         >
                                                             {exchanges.filter(exchange => exchange.value != 'Custom Script').map((exchange) => (
                                                                 <Option key={exchange.value} value={exchange.value}>
                                                                     {exchange.label}
                                                                 </Option>
                                                             ))}
                                                         </Select>
                                                     
                                                         {selectedExchange === 'hollaex' && <div style={{ color: "white", margin: "30px 0" }}>
                                                                <label>Custom API Url (Optional)</label>
                                                                <Input value={customURls.custom_api_url} onChange={(e) => { setCustomUrls({ ...customURls, custom_api_url: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input Custom Url" />
                                                            </div>}
                                                            {selectedExchange === 'hollaex' && <div style={{ color: "white", margin: "10px 0" }}>
                                                                <label>Custom Websocket Url (Optional)</label>
                                                                <Input value={customURls.custom_websocket_url} onChange={(e) => { setCustomUrls({ ...customURls, custom_websocket_url: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input Custom Url" />
                                                            </div>}
                                                            {selectedExchange === 'hollaex'  && <div>
                                                                <Checkbox checked={customURls.is_sandbox} style={{ color: "white", marginBottom: 15 }} onChange={(e) => {
                                                                    setCustomUrls({ ...customURls, is_sandbox: e.target.checked });
                                                                }}>Sandbox mode </Checkbox>
                                                            
                                                            </div>}
                                                            {selectedExchange === 'hollaex'  && <div>
                                                            <Button onClick={() => {
                                                                handleChange(selectedExchange);
                                                            
                                                            }} style={{ backgroundColor: "#161616", color: "white", flex: 1, }} type="default">Fetch the price with the custom urls </Button>
                                                            </div>}

                                                           
                                                     </div>
                                                    }
                                                    {/* You selected a different market than the strategy's market. Would you like to apply your custom market config to this market? This will override price you will get from the selected exchange  (If you don't have a custom config for the selected market, Please create one on 'MY MARKET CONFIG' page) */}
                                                </div>

                                                <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                                                    <Button onClick={() => {
                                                        setAssetRebalanceInfo({
                                                            ...assetRebalanceInfo,
                                                            customMarketConfig: null,
                                                            hasMarketConfig: false
                                                        })
                                                        // setConversionMarket();
                                                        setErrorMessage('');
                                                        // setDisplayWarning(true);
                                                        setDisplayCustomMarket(false);

                                                    }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">NO</Button>
                                                    <Button onClick={() => {
                                                        setAssetRebalanceInfo({
                                                            ...assetRebalanceInfo,
                                                            customMarketConfig: conversionObj?.customConfig,
                                                            hasMarketConfig: true,
                                                        })
                                                        setErrorMessage('');
                                                        setDisplayCustomMarket(false);

                                                    }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">YES</Button>
                                                </div>

                                            </Modal>
                                            }

                                            {displayWarning && <Modal
                                                maskClosable={false}
                                                closeIcon={<CloseOutlined style={{ color: "white" }} />}
                                                bodyStyle={{
                                                    backgroundColor: 'black',
                                                    border: "1px solid grey"
                                                }}
                                                // style={{ marginTop: 40 }}
                                                visible={displayWarning} footer={null} onCancel={() => { setDisplayWarning(false); }}>

                                                <div style={{ fontWeight: "600", color: "white" }}>
                                                    <WarningOutlined /> Different Market Warning
                                                </div>
                                                <div style={{ color: "grey", marginTop: 20, marginBottom: 40 }}>
                                                    {errorMessage ? `Conversion not found for the selected market` : `You chose not to apply the conversion. Keep in my mind that this source price does not belong to the strategy's market.`}
                                                </div>

                                                <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                                                    <Button onClick={() => {
                                                        setErrorMessage('');
                                                        setDisplayWarning(false);
                                                    }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">OK</Button>

                                                </div>

                                            </Modal>
                                            }

                                            <Checkbox checked={assetRebalanceInfo?.hasMarketConfig} style={{ color: "white", marginBottom: 20 }} onChange={(e) => {
                                                if (e.target.checked) {

                                                    message.loading({ content: 'finding conversion...', key: 'conversion', duration: 0 });
                                                    calculateConversion({
                                                        exchangeId: orderItem?.source,
                                                        selectedSymbol: orderItem?.symbol,
                                                        marketFocus: assetRebalanceInfo?.symbol,
                                                        userId,
                                                        isSandbox: orderItem?.isSandbox,
                                                        isRebalance: true,
                                                        conversion: orderItem?.conversionMarket,
                                                        sourceSymbol: orderItem?.source_symbol
                                                    }).then(res => {
                                                        if (res.error) {
                                                            setErrorMessage(res.error);
                                                            setDisplayWarning(true);
                                                        } else {
                                                            setConversionObj(res)
                                                            setDisplayCustomMarket(true);
                                                            setErrorMessage('')
                                                        }
                                                        message.destroy('conversion');
                                                    })

                                                } else {
                                                    setAssetRebalanceInfo({ ...assetRebalanceInfo, hasMarketConfig: e.target.checked, customMarketConfig: null })
                                                }

                                            }}>Apply custom market config </Checkbox>
                                        </>

                                    }



                                    <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                                        <Button onClick={() => { setDisplaySubRebalance(false); }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">BACK</Button>
                                        <Button onClick={() => {
                                            handleAssetRebalance();
                                        }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">COMPLETE</Button>
                                    </div>

                                </Modal>
                            </>}
                        </> : <>
                            <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                                <Select
                                    showSearch
                                    value={customUniswapPair?.symbol1 || null}
                                    placeholder="Select First Token"
                                    style={{ color: "black", width: "100%" }}
                                    notFoundContent={'Not Found'}
                                    onChange={(value) => { setCustomUniswapPair({ ...customUniswapPair, token1: JSON.parse(value).token_address, symbol1: JSON.parse(value).symbol }) }}
                                >
                                    {uniswapPairs.map(token => <Option value={JSON.stringify(token)}>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}
                                        >
                                            <div>{token.symbol}</div>
                                            <Button
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    const tokenList = localStorage.getItem(`${profile.exchange}_token_list`);
                                                    let parsed = JSON.parse(tokenList);
                                                    parsed = parsed.filter(x => x.token_address !== token.token_address)
                                                    localStorage.setItem(`${profile.exchange}_token_list`, JSON.stringify(parsed));
                                                    setUniswapPairs(parsed);
                                                    setCustomUniswapPair({ ...customUniswapPair, token1: null, symbol1: null })
                                                }}
                                                danger size="small">
                                                Delete
                                            </Button>
                                        </div>
                                    </Option>)}

                                </Select>

                                <Select
                                    showSearch
                                    value={customUniswapPair?.symbol2 || null}
                                    placeholder="Select Second Token"
                                    style={{ color: "black", width: "100%" }}
                                    notFoundContent={'Not Found'}
                                    onChange={(value) => { setCustomUniswapPair({ ...customUniswapPair, token2: JSON.parse(value).token_address, symbol2: JSON.parse(value).symbol }) }}
                                >
                                    {uniswapPairs.map(token => <Option value={JSON.stringify(token)}>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}
                                        >
                                            <div>{token.symbol}</div>
                                            <Button
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    const tokenList = localStorage.getItem(`${profile.exchange}_token_list`);
                                                    let parsed = JSON.parse(tokenList);
                                                    parsed = parsed.filter(x => x.token_address !== token.token_address)
                                                    localStorage.setItem(`${profile.exchange}_token_list`, JSON.stringify(parsed));
                                                    setUniswapPairs(parsed);
                                                    setCustomUniswapPair({ ...customUniswapPair, token2: null, symbol2: null })
                                                }}
                                                danger size="small">
                                                Delete
                                            </Button>
                                        </div>
                                    </Option>)}

                                </Select>

                                <Button
                                    style={{ backgroundColor: "#161616", color: "white", }}
                                    onClick={() => { setDisplayAddToken(true) }}
                                    type="primary" icon={<PlusCircleOutlined />}>
                                    Add Token
                                </Button>

                            </div>

                            <Modal
                                maskClosable={false}
                                closeIcon={<CloseOutlined style={{ color: "white" }} />}
                                bodyStyle={{
                                    backgroundColor: 'black',
                                    border: "1px solid grey"
                                }}
                                visible={displayAddToken} footer={null} onCancel={() => { setDisplayAddToken(false); }}>
                                <div style={{ fontWeight: "600", color: "white" }}>Add Token</div>
                                <div>
                                    <div style={{ color: "white", margin: "30px 0" }}>
                                        <label>Token Symbol(e.g: xht)</label>
                                        <Input value={addToken?.symbol} onChange={(e) => { setAddToken({ ...addToken, symbol: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input token symbol" />
                                    </div>
                                    <div style={{ color: "white", margin: "30px 0" }}>
                                        <label>Token Address</label>
                                        <Input value={addToken?.token_address} onChange={(e) => { setAddToken({ ...addToken, token_address: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input first token address" />
                                    </div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                                    <Button onClick={() => { setDisplayAddToken(false); }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">BACK</Button>
                                    <Button onClick={() => {
                                        const tokenList = localStorage.getItem(`${profile.exchange}_token_list`);
                                        if (tokenList) {
                                            const parsed = JSON.parse(tokenList);
                                            if (!addToken?.symbol || !addToken?.token_address) {
                                                message.error({ content: 'Please fill the input boxes' })
                                                return;
                                            }
                                            if (parsed.find(x => x.token_address === addToken?.token_address) || parsed.find(x => x.symbol === addToken?.symbol?.toLowerCase())) {
                                                message.error({ content: 'Token already in the list' })
                                                return;
                                            }
                                            if (addToken?.symbol?.indexOf(' ') >= 0) {
                                                message.error({ content: 'Invalid Symbol' })
                                                return;
                                            }
                                            parsed.push(addToken);
                                            localStorage.setItem(`${profile.exchange}_token_list`, JSON.stringify(parsed));
                                            setUniswapPairs(parsed);
                                        } else {
                                            localStorage.setItem(`${profile.exchange}_token_list`, JSON.stringify([addToken]));
                                            setUniswapPairs([addToken]);
                                        }
                                        setAddToken();
                                        setDisplayAddToken(false);
                                    }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">COMPLETE</Button>
                                </div>

                            </Modal>

                            {dex.includes(profile.exchange) &&
                                <div style={{ display: "flex", flexDirection: "column", marginTop: 15 }}>
                                    <span>Network Option</span>
                                    <Radio.Group style={{ marginTop: 5 }} onChange={((e) => {
                                        setSelectedNetwork(e.target.value)
                                    })}
                                        value={selectedNetwork}
                                    >
                                        <Space direction="vertical">
                                            <Radio style={{ color: "white" }} value={'mainnet'}>Mainnet</Radio>
                                            <Radio style={{ color: "white" }} value={'ropsten'}>Ropsten</Radio>
                                            <Radio style={{ color: "white" }} value={'rinkeby'}>Rinkeby</Radio>
                                        </Space>
                                    </Radio.Group>
                                </div>
                            }

                        </>}


                        {/* <Select
                            style={{ width: "100%", marginTop: 10 }}
                            placeholder="Select rebalance symbol"

                        >
                            <Option value="1">BTC/USDT</Option>
                        </Select> */}
                    </div>
                </>
            }


            <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                <Button onClick={() => { goBack() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">BACK</Button>
                <Button
                    // disabled={step == 0 && !newProfile.exchange}
                    onClick={() => {
                        if (!dex.includes(profile.exchange)) {
                            onClickNext()
                        } else {
                            handleConnectToDEX();
                        }
                    }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">Next</Button>

            </div>
        </Modal>
    );
};

export default SelectRebalanceProfile;